import type { JSX } from "react";

import { Text } from "@mantine/core";

export function Header({ text }: { text: string }): JSX.Element {
    return (
        <Text fw="var(--mantine-font-weight-heavy)" c="dark.1">
            {text}
        </Text>
    );
}
